/* assets/ziella-engraving.js
 * Ziella engraving toggle (reworked 18 Sep 2026)
 *
 * The +$5 engraving is carried by the product's own variants: every gift-box option value has
 * an engraved twin named "<box> + Engraving (+$5)". snippets/variant-picker.liquid renders those
 * twins as HIDDEN radios (data-ziella-engraved-for="<plain value id>") inside the normal option
 * group, so the theme's variant picker can select them like any other value.
 *
 * This script:
 *  - maps the "Add custom engraving" Yes/No toggle (snippets/product-customization.liquid, type
 *    'Engraving Add-On') to those hidden radios: Yes -> check the twin of the chosen box,
 *    No -> check the plain box again. The theme then re-renders price, buy button, etc.
 *  - keeps the toggle ON when the shopper picks a different box card (the plain radio the card
 *    checks is swapped for its twin before the theme sees the change)
 *  - shows/hides + enables/disables the engraving text field (properties[<label>]) and
 *    validates it on add-to-cart
 *  - keeps the typed text across the theme's product-info re-renders
 *
 * Result: ONE cart line at the engraved variant price, with "Engraving: <text>" as a property.
 * No separate service product, no cart reconciliation.
 */
(function () {
  if (window.__ziellaEngravingLoaded) return;
  window.__ziellaEngravingLoaded = true;

  var state = {}; // formId -> { engrave: bool|null, text: string }

  function blocks() { return document.querySelectorAll('[data-ziella-engrave]'); }
  function blockFor(formId) { return document.querySelector('[data-ziella-engrave][data-form-id="' + formId + '"]'); }
  function pickerFor(formId) { return document.querySelector('variant-picker[form-id="' + formId + '"]'); }
  function stateFor(formId) { return state[formId] || (state[formId] = { engrave: null, text: '' }); }

  // All radios of the gift-box option group (plain + hidden engraved twins) for a form.
  function boxRadios(formId) {
    var picker = pickerFor(formId);
    if (!picker) return [];
    var twin = picker.querySelector('input[data-ziella-engraved-for]');
    if (!twin) return [];
    return Array.prototype.slice.call(picker.querySelectorAll('input[name="' + twin.name + '"]'));
  }
  function checkedBox(formId) {
    var radios = boxRadios(formId);
    for (var i = 0; i < radios.length; i++) if (radios[i].checked) return radios[i];
    return null;
  }
  function isEngraved(formId) {
    var c = checkedBox(formId);
    return !!(c && c.hasAttribute('data-ziella-engraved-for'));
  }
  function select(radio) {
    if (!radio || radio.checked) return false;
    radio.checked = true;
    radio.dispatchEvent(new Event('change', { bubbles: true })); // the theme's variant picker listens for this
    return true;
  }
  function setEngraved(formId, on) {
    var c = checkedBox(formId);
    if (!c) return;
    var radios = boxRadios(formId);
    var isTwin = c.hasAttribute('data-ziella-engraved-for');
    if (on && !isTwin) {
      select(radios.filter(function (r) { return r.getAttribute('data-ziella-engraved-for') === c.value; })[0]);
    } else if (!on && isTwin) {
      var plainId = c.getAttribute('data-ziella-engraved-for');
      select(radios.filter(function (r) { return r.value === plainId; })[0]);
    }
  }

  function applyBlock(block) {
    var formId = block.getAttribute('data-form-id');
    var st = stateFor(formId);
    var on = isEngraved(formId);
    if (st.engrave === null) st.engrave = on; // first sight: trust the rendered variant (?variant= links)
    block.querySelectorAll('[data-ziella-engrave-choice]').forEach(function (r) {
      var want = (r.value === 'yes') === on;
      if (r.checked !== want) r.checked = want;
    });
    var fields = block.querySelector('[data-ziella-engrave-fields]');
    var text = block.querySelector('[data-ziella-engrave-text]');
    var err = block.querySelector('[data-ziella-engrave-error]');
    if (fields && fields.hidden === on) fields.hidden = !on;
    if (text) {
      if (text.disabled !== !on) text.disabled = !on;
      if (text.required !== on) text.required = on;
      if (on && st.text && text.value !== st.text && document.activeElement !== text) text.value = st.text;
      if (!on && text.value) { text.value = ''; text.dispatchEvent(new Event('input', { bubbles: true })); }
    }
    if (!on && err && !err.hidden) err.hidden = true;
  }
  function applyAll() { blocks().forEach(applyBlock); }

  // Yes / No toggle
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.hasAttribute || !t.hasAttribute('data-ziella-engrave-choice')) return;
    var block = t.closest('[data-ziella-engrave]');
    if (!block) return;
    var formId = block.getAttribute('data-form-id');
    var st = stateFor(formId);
    st.engrave = t.value === 'yes';
    setEngraved(formId, st.engrave);
    applyBlock(block);
    if (st.engrave) {
      var text = block.querySelector('[data-ziella-engrave-text]');
      if (text) setTimeout(function () { text.focus(); }, 0);
    }
  });

  // A visible box card was tapped while engraving is on: hand the theme the engraved twin instead.
  // Capture phase on document runs before the theme's body-level delegate.
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('input[data-option-position]') || t.hasAttribute('data-ziella-engraved-for')) return;
    var picker = t.closest('variant-picker');
    if (!picker) return;
    var twin = picker.querySelector('input[data-ziella-engraved-for="' + t.value + '"]');
    if (!twin) return; // not a gift-box value with an engraved twin
    var st = state[picker.getAttribute('form-id')];
    if (!st || !st.engrave) return;
    e.stopImmediatePropagation();
    select(twin);
  }, true);

  // Remember the typed text across re-renders
  document.addEventListener('input', function (e) {
    var t = e.target;
    if (!t || !t.hasAttribute || !t.hasAttribute('data-ziella-engrave-text')) return;
    var block = t.closest('[data-ziella-engrave]');
    if (!block) return;
    stateFor(block.getAttribute('data-form-id')).text = t.value;
    var err = block.querySelector('[data-ziella-engrave-error]');
    if (err && t.value.trim()) err.hidden = true;
  });

  // Validate before the theme's product-form submit handler runs (capture phase).
  document.addEventListener('submit', function (e) {
    var form = e.target;
    var formId = form && form.getAttribute ? form.getAttribute('id') : null; // form.id is the <input name="id">
    if (!formId) return;
    var block = blockFor(formId);
    if (!block) return;
    var text = block.querySelector('[data-ziella-engrave-text]');
    var err = block.querySelector('[data-ziella-engrave-error]');
    var on = isEngraved(formId);
    if (!on) { if (text) text.disabled = true; return; } // no engraving: never send the property
    var value = text ? text.value.trim() : '';
    if (!value) {
      e.preventDefault();
      e.stopImmediatePropagation();
      if (err) err.hidden = false;
      if (text) { text.classList.add('error'); text.focus(); text.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
      return;
    }
    if (text) { text.value = value; text.classList.remove('error'); text.disabled = false; }
  }, true);

  document.addEventListener('variant:change', function () { setTimeout(applyAll, 10); });

  window.ziellaEngravingDebug = { state: state, isEngraved: isEngraved, setEngraved: setEngraved };
  function boot() {
    applyAll();
    var applying = false;
    new MutationObserver(function () {
      if (applying || !blocks().length) return;
      applying = true;
      try { applyAll(); } finally { applying = false; }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
